let _ = t => t,
  _t;
import { createCopilotChannel } from '../channel/createCopilotChannel';
import { COPILOT_APP_CONTAINER_CLASS, COPILOT_GRID_LAYOUT_CLASS, COPILOT_SIDEBAR_CONTAINER_CLASS, PANEL_WITH_SCROLL_CLASS, SIDEBAR_CLASS } from '../constants/LayoutClasses';
import { createRoot } from 'react-dom/client';
import { render } from 'react-dom';
import { createGlobalStyle } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CopilotStyles = createGlobalStyle(_t || (_t = _`
  .${0} {
    &.${0} {
      display: grid;
      max-width: 100%;
      overflow-y: hidden;
      grid-template-columns: 1fr 0px;
    }
    &.${0} {
      display: grid;
      max-width: 100%;
      overflow-y: hidden;
      grid-template-columns: 1fr auto;
    }
    > .${0} {
      min-width: 0;
      min-height: 0;
    }
  }
`), COPILOT_GRID_LAYOUT_CLASS, PANEL_WITH_SCROLL_CLASS, SIDEBAR_CLASS, COPILOT_APP_CONTAINER_CLASS);
const renderApp = (app, renderTarget, {
  useCreateRoot
}) => {
  if (useCreateRoot) {
    createRoot(renderTarget).render( /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(CopilotStyles, {}), app]
    }));
  } else {
    render( /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(CopilotStyles, {}), app]
    }), renderTarget);
  }
};
export const renderWithNavCopilot = (app, {
  fallbackRenderTarget = document.getElementsByClassName('page')[0],
  layoutType,
  useCreateRoot
}) => {
  const gridContainer = document.querySelector(`.${COPILOT_GRID_LAYOUT_CLASS}`);
  const appContainer = document.querySelector(`.${COPILOT_APP_CONTAINER_CLASS}`);
  const channel = createCopilotChannel();
  channel.setState({
    layoutType
  });
  if (layoutType === 'panel') {
    const maybeSidebarElement = document.querySelector(`.${COPILOT_SIDEBAR_CONTAINER_CLASS}`);

    // Move the sidebar element to the body so it doesn't get deleted by the app
    // when it renders. It doesn't matter where the element is as long as it's
    // on the page for the panel layout so we just put it on the body
    if (maybeSidebarElement) {
      document.body.appendChild(maybeSidebarElement);
    }
    renderApp(app, fallbackRenderTarget, {
      useCreateRoot
    });
    return;
  }

  // Make sure both the required layout containers are here before trying to
  // render a copilot layout
  if (gridContainer && appContainer) {
    if (layoutType === 'panel-with-scroll') {
      gridContainer.classList.add(PANEL_WITH_SCROLL_CLASS);
      renderApp(app, appContainer, {
        useCreateRoot
      });
      return;
    } else if (layoutType === 'sidebar') {
      gridContainer.classList.add(SIDEBAR_CLASS);
      renderApp(app, appContainer, {
        useCreateRoot
      });
      return;
    }
  }
  return renderApp(app, fallbackRenderTarget, {
    useCreateRoot
  });
};